'use client';

import Image from 'next/image';
import { useState, useEffect } from 'react';
import { Phone, Mail, Globe, Linkedin, Download, Share2, Crown } from 'lucide-react';
import styles from './greeting.module.css';

export default function ContactCard() {
  const [isMobile, setIsMobile] = useState(false);
  const [photoData, setPhotoData] = useState<string | null>(null);

  useEffect(() => {
    setIsMobile('share' in navigator);
    loadPhoto();
  }, []);

  const loadPhoto = async () => {
    try {
      const response = await fetch('/Guardian_Notary_Final.png');
      const blob = await response.blob();
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64data = reader.result as string;
        setPhotoData(base64data.split(',')[1]);
      };
      reader.readAsDataURL(blob);
    } catch (error) {
      console.error('Error loading photo:', error);
    }
  };

  const handleSaveContact = async () => {
    const vcard = `BEGIN:VCARD
VERSION:3.0
FN:Linda Close
N:Close;Linda;;;
TITLE:Mobile Notary Service
TEL:+16176990338
EMAIL:linda@theguardiannotary.com
URL:https://theguardiannotary.com
END:VCARD`;

    const blob = new Blob([vcard], { type: 'text/vcard' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'linda-close.vcf');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Guardian Notary',
          text: 'Connect with Guardian Notary - Mobile Notary Service',
          url: window.location.href,
        });
      } catch (error) {
        // Silently ignore share cancellations
      }
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.imageWrapper}>
            <Image
              src="/Guardian_Notary_Final.png"
              alt="Guardian Notary Logo"
              width={180}
              height={180}
              priority
            />
          </div>
          <div className={styles.headerContent}>
            <h1 className={styles.name}>Guardian Notary</h1>
            <div className={styles.titleWrapper}>
              <p className={styles.title}>Mobile Notary Service</p>
              <div className={styles.company}>
                <Crown className={styles.buildingIcon} />
                <span>Professional & Reliable</span>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.contactGrid}>
          <a
            href="tel:+16176990338"
            className={styles.contactItem}
          >
            <Phone className={styles.icon} />
            <span>Call</span>
          </a>
          <a
            href="mailto:linda@theguardiannotary.com"
            className={styles.contactItem}
          >
            <Mail className={styles.icon} />
            <span>Email</span>
          </a>
          <a
            href="https://theguardiannotary.com"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.contactItem}
          >
            <Globe className={styles.icon} />
            <span>Website</span>
          </a>
          <a
            href="#"
            className={styles.contactItem}
            onClick={(e) => {
              e.preventDefault();
              handleSaveContact();
            }}
          >
            <Download className={styles.icon} />
            <span>Save</span>
          </a>
        </div>

        {isMobile && (
          <div className={styles.actions}>
            <button onClick={handleShare} className={`${styles.button} ${styles.primary}`}>
              <Share2 className={styles.buttonIcon} />
              Share Contact
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
